<template>
  <div class="page_">
    <topBar />
    <div class="title_">账号注册</div>
    <div class="content_">
      <a-form
        :hideRequiredMark="true"
        class="form_ form_error_right_"
        layout="horizontal"
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item class="mrg_b11_ phone_input" :labelCol="{ span: 6 }" label="手机号">
          <a-input
            type="number"
            v-decorator="[
              'loginName',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入正确的手机号',
                    pattern: /1\d{10}/,
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item class="mrg_b11_" :labelCol="{ span: 6 }" label="设置密码">
          <a-input
            type="password"
            v-decorator="[
              'passWord',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入密码',
                  },
                  {
                    validator: validateToNextPassword,
                  },
                ],
              },
            ]"
          ></a-input>
          <p class="waring_" v-if="showwaring1">密码位数必须为8位，同时包含数字和字母</p>
        </a-form-item>
        <a-form-item class="mrg_b11_" :labelCol="{ span: 6 }" label="确认密码">
          <a-input
            type="password"
            v-decorator="[
              'confirmPwd',
              {
                rules: [
                  {
                    required: true,
                    message: '请确认密码',
                  },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              },
            ]"
            @blur="handleConfirmBlur"
          ></a-input>
          <p class="waring_" v-if="showwaring2">密码位数必须为8位，同时包含数字和字母</p>
        </a-form-item>
        <a-form-item class="mrg_b11_" :labelCol="{ span: 6 }" label="证件类型">
          <a-select
            @change="handleIdTypeChange"
            v-decorator="[
              'idType',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择证件类型',
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="item in commonIdTypeOptions"
              :key="item.value"
              :value="item.value"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="mrg_b11_" :labelCol="{ span: 6 }" label="证件号码">
          <a-input
            v-decorator="[
              'idNumber',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入证件号码',
                  },
                  {
                    validator: checkIDNumber,
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          class="mrg_b0_ mrg_b11_"
          :labelCol="{ span: 6 }"
          label="验证码"
        >
          <sendCode v-model="smsCode" field="verifyCode" :form="form" />
        </a-form-item>
        <div class="asked_">
          <a-row>
            <a-col :offset="6" :span="18">
              注册即代表以阅读并同意<router-link :to="{ name: '' }" class="c11_"
                >《用户协议》</router-link
              >
            </a-col>
          </a-row>
        </div>
        <div class="clearfix_">
          <a-button class="btn_register_ f_r_" html-type="submit" type="primary"
            >注册</a-button
          >
        </div>
        <div class="b_">
          <router-link :to="{ name: 'login' }" class="c11_"
            >已有账户，去登录<i class="i_arrow_"></i
          ></router-link>
        </div>
      </a-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.page_ {
  min-height: 100vh;
  background: #f6f6f6;
  text-align: center;
  .b_ {
    text-align: center;
    margin-top: 18px;
    font-size: 12px;
  }
  .mrg_b11_ {
    margin-bottom: 16px;
    position:relative;
  }
  .title_ {
    font-size: 27px;
    color: #000000;
    margin: 49px 0 40px;
  }
  .waring_{
    position: absolute;
    top: 18px;
    left: 0;
    right: 0;
    color: #f5222d;
    font-size: 12px;
}
  .content_ {
    width: 814px;
    height: 538px;
    padding: 66px 0;
    margin: 0 auto;
    background: #fff;
    border-radius: 13px;
    .asked_ {
      text-align: left;
      margin: 19px 0 26px;
      font-size: 12px;
    }
    .form_ {
      width: 310px;
      margin: 0 auto;
      text-align: left;
    }
    .btn_register_ {
      width: 299px;
      height: 42px;
      background: rgba(255, 76, 28, 1);
    }
    .i_arrow_ {
      position: relative;
      display: inline-block;
      top: 2px;
      margin-left: 8px;
      width: 12px;
      height: 12px;
      background: url("../../assets/wxmall/3.png") no-repeat;
      background-size: 100% auto;
    }
  }
}
</style>
<script>
import topBar from "./components/topBar";
import sendCode from "./components/sendCode";
import api from "@/utils/api";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      commonIdTypeOptions: [
        { name: "身份证", value: "1" },
        { name: "护照", value: "2" },
      ],
      count: 0,
      smsCode: "",
      showwaring1:false,
      showwaring2:false,
    };
  },
  components: {
    topBar,
    sendCode,
  },
  mounted() {
    // this.startCountDown()
  },
  methods: {
    handleIdTypeChange() {
      this.form.setFieldsValue({
        idNumber: "",
      });
    },
    checkIDNumber(rule, value, callback, origin) {
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      let form = this.form;
      if (
        value &&
        form.getFieldValue("idType") == "1" &&
        !regIdCard.test(value)
      ) {
        callback("身份证号码不正确");
      } else {
        callback();
      }
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
      if (value.length != 8 || !reg.test(value)) {
          this.showwaring2=true
      } else {
          this.showwaring2=false
        const form = this.form;
        if (value && value !== form.getFieldValue("passWord")) {
            callback("两个密码不一致!");
        } else {
            callback();
        }
      }
    },
    validateToNextPassword(rule, value, callback) {
      var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
      if (value.length != 8 || !reg.test(value)) {
          this.showwaring1=true
      } else {
          this.showwaring1=false
        const form = this.form;
        if (value && this.confirmDirty) {
            form.validateFields(["confirmPwd"], { force: true });
        }
        callback();
      }
    },
    handleSubmit(e) {
      e && e.preventDefault();
      console.log("e -> ", 1);
      this.form.validateFields((error, values) => {
        if (!error) {
          var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
          if (values.passWord.length != 8 || !reg.test(values.passWord)) {
            this.$message.warning(`密码位数必须为8位，同时包含数字和字母`, 3);
            return;
          } else {
            api
              .register({
                ...values,
                verifyCode: this.smsCode,
              })
              .then((res) => res.data)
              .then((data) => {
                this.$message.info("注册成功，准备跳转...");
                let st = setTimeout(() => {
                  clearTimeout(st);
                  this.$router.push({
                    name: "login",
                  });
                }, 1000);
              });
          }
        }
      });
    },
  },
};
</script>
